import { render, staticRenderFns } from "./editGarden.vue?vue&type=template&id=1c4b30ff&scoped=true&"
import script from "./editGarden.vue?vue&type=script&lang=js&"
export * from "./editGarden.vue?vue&type=script&lang=js&"
import style0 from "./editGarden.vue?vue&type=style&index=0&id=1c4b30ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b30ff",
  null
  
)

export default component.exports